import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CotizacionColectivoContacto  } from '../../models/cotizacion-colectivo-contacto/cotizacion-colectivo-contacto.model';
import { environment } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';

@Injectable({
  providedIn: 'root'
})
export class CotizacionColectivoContactoService {

  private baseUrl =  `${environment.HOST}${URL_MAP.API.COTIZACIONCOLECTIVOCONTACTO}`;

  constructor(private http: HttpClient) {}

  crear(contacto: CotizacionColectivoContacto): Observable<CotizacionColectivoContacto> {
    return this.http.post<CotizacionColectivoContacto>(this.baseUrl, contacto);
  }

  crearMasivo(contactos: CotizacionColectivoContacto[]): Observable<CotizacionColectivoContacto[]> {
    return this.http.post<CotizacionColectivoContacto[]>(`${this.baseUrl}/guardar`, contactos);
  }

  listar(): Observable<CotizacionColectivoContacto[]> {
    return this.http.get<CotizacionColectivoContacto[]>(this.baseUrl);
  }

  obtenerPorId(id: number): Observable<CotizacionColectivoContacto> {
    return this.http.get<CotizacionColectivoContacto>(`${this.baseUrl}/${id}`);
  }

  obtenerPorCotizacion(idCotizacion: number): Observable<CotizacionColectivoContacto[]> {
    return this.http.get<CotizacionColectivoContacto[]>(`${this.baseUrl}/cotizacion/${idCotizacion}`);
  }

  actualizar(contacto: CotizacionColectivoContacto): Observable<CotizacionColectivoContacto> {
    if (!contacto.idContacto) {
      throw new Error('idContacto es requerido para actualizar un contacto colectivo');
    }
    return this.http.put<CotizacionColectivoContacto>(`${this.baseUrl}/${contacto.idContacto}`, contacto);
  }

  sincronizar(idCotizacion: number, contactos: CotizacionColectivoContacto[]): Observable<CotizacionColectivoContacto[]> {
    return this.http.put<CotizacionColectivoContacto[]>(`${this.baseUrl}/cotizacion/${idCotizacion}/sincronizar`, contactos);
  }

  obtenerPorColectivo(idColectivo: number): Observable<CotizacionColectivoContacto[]> {
    return this.http.get<CotizacionColectivoContacto[]>(`${this.baseUrl}/colectivo/${idColectivo}`);
  }

  eliminar(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}